import { configureStore } from '@reduxjs/toolkit';
import cardsReducer from './slices/cardSlice';

export const store = configureStore({
  reducer: {
    cards: cardsReducer
  }
});

export default store;
